export interface ShiftRosterCopyModel {
    readonly shiftId: number;
    readonly sourceFrom: string;
    readonly sourceTo: string;
    readonly targetFrom: string;
    readonly repeat: number;
    readonly overwrite: boolean;
}
